import { useEffect, useState } from "react";

type Props = {
  blob?: Blob;
};

const BillPdfPreview = ({ blob }: Props) => {
  const [pdfUrl, setPdfUrl] = useState<string>();

  useEffect(() => {
    if (!blob) return;

    const url = URL.createObjectURL(blob);
    setPdfUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  if (!pdfUrl) return null;

  return (
    <iframe
      src={pdfUrl}
      title="Corrected Bill Preview"
      width="100%"
      height="600"
      style={{ border: "none" }}
    />
  );
};

export default BillPdfPreview;
